import { useState } from 'react';

import { map } from 'lodash';
import useSWR from 'swr';

// Utils
import { get } from '@/utils/client';
import { injectEndpointUrlParams } from '@/utils/injectEndpointUrlParams';

// API Endpoints
import { LABELS } from '@/lib/routes/apiEndpoints';

export const formatLabelList = (list) =>
    map(list, (el) => ({ label: el.label, value: el.label, id: el.id }));

const useLabels = ({
    activeSPID = undefined,
    options = {},
    params = undefined,
    shouldFetch = true
} = {}) => {
    const [requestParams, setRequestParams] = useState(params);

    const apiEndpoint = injectEndpointUrlParams(LABELS, {
        SPID: activeSPID
    });
    const {
        data: labels,
        mutate: mutateLabels,
        error: errorLabels,
        isLoading
    } = useSWR(
        shouldFetch
            ? [apiEndpoint, requestParams ? JSON.stringify(requestParams) : undefined]
            : null,
        ([url]) => get(url, requestParams).then((res) => res.data?.data),
        {
            shouldRetryOnError: false,
            ...options
        }
    );

    return {
        labels,
        mutateLabels,
        errorLabels,
        isLoading,
        requestParams,
        setRequestParams
    };
};

export default useLabels;
